import { VehicleHistoryEvent } from './vehicle-history-event';
import moment from 'moment';

export class VehicleAtStopEvent extends VehicleHistoryEvent {
    public type = 'VehicleAtStopEvent';

    plannedArrival?: Date;
    plannedDeparture?: Date;

    progressType?: string;
    deviation?: number;

    // Comes from the StopMetaData
    trafficDate: Date;
    geoFenceName: string;
    vehicleTaskNumber: string;
    sequenceNumber: number;
    isLastOnActivity: boolean;
    activityType: string;
    tripNumber: string;
    activityStartTime: string;
    routeName: string;
    routePublicName: string;
    placeId: string;
    nextPlaceId: string;
    isMeasurementStop: boolean;
    isTimingPoint: boolean;
    isLastInVehicleActivity: boolean;

    constructor(obj = null) {
        super();

        if (obj) {
            Object.assign(this, obj);
        }

        if (obj?.metadata) {
            Object.assign(this, obj?.metadata);
        }

        if (obj?.trafficDate) {
            this.trafficDate = moment(obj.ts).toDate();
        }

        if (obj?.plannedArrival) {
            this.plannedArrival = moment(obj.plannedArrival).toDate();
        }

        if (obj?.plannedDeparture) {
            this.plannedDeparture = moment(obj.plannedDeparture).toDate();
        }
    }
}